/* eslint-disable no-undef */
import axios from 'axios';
import ExprEval from 'expr-eval';
import StringUtils from 'lib/StringUtils';
import ModalUtils from 'utils/ModalUtils';
import KeyStore from 'utils/KeyStore';

const {
    REACT_APP_GRAPHQL_HTTP,
} = process.env;

const keyStore = new KeyStore();
export default class GeneralUtils {
    static downloadRecordingFile = async (callId) => {
        try {
            const response = await axios.post(`${REACT_APP_GRAPHQL_HTTP}/download-voice-recording`, { callId }, {
                responseType: 'blob',
                headers: {
                    authorization: `Bearer ${keyStore.getToken()}`,
                },
            });

            const blob = new Blob([response.data], {
                type: response.headers['content-type'],
            });

            return window.URL.createObjectURL(blob);
        } catch (_) {
            ModalUtils.errorMessage(null, 'Error downloading recording file');
            return null;
        }
    };

    static downloadFile = async (url, name, buffer, fileType) => {
        let address = null;
        if (buffer && type) {
            const blob = new Blob([buffer], { fileType });
            address = URL.createObjectURL(blob);
        } else {
            try {
                const response = await fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit' });
                const blob = await response.blob();
                address = URL.createObjectURL(blob);
            } catch (error) {
                ModalUtils.errorMessage(null, 'Error downloading file');
            }
        }

        if (StringUtils.isEmpty(address)) return;
        const link = document.createElement('a');
        link.href = address;
        link.download = name;
        document.body.appendChild(link);

        link.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            }),
        );

        document.body.removeChild(link);
    };

    static sendGraphQLPersistentRequest = (body) => {
        const URL = process.env.REACT_APP_GRAPHQL_HTTP;
        const token = `Bearer ${keyStore.getToken()}`;

        fetch(
            URL,
            {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'x-auth-type': 'oauth2',
                    authorization: token || '',
                },
                body: JSON.stringify(body),
                keepalive: true,
            },
        );
    };

    static addExternalScript = (url) => {
        const scriptName = 'externalScript';
        let script = document.getElementById(scriptName);

        if (!script) {
            script = document.createElement('script');
            script.id = scriptName;
            script.src = url;
            script.defer = true;
            document.body.appendChild(script);
        }
    };

    static async sleep(delayInSeconds) {
        const milliseconds = delayInSeconds * 1000;
        return new Promise((resolve) => setTimeout(resolve, milliseconds));
    }

    static validateFormula(variables, formula) {
        if (StringUtils.isEmpty(formula) || !Array.isArray(variables)) return false;

        let replacedFormula = formula;
        variables.forEach(({ variable, value }) => { replacedFormula = replacedFormula.replaceAll(variable, String(value)); });

        try {
            ExprEval.Parser.evaluate(replacedFormula);
            return true;
        } catch (_) {
            return false;
        }
    }

    static isModuleEnabled(userContext, module = '') {
        if (StringUtils.isEmpty(module)) return false;

        const { userInformation } = userContext ?? {};
        if (!userInformation) return false;

        const { company = {} } = userInformation;
        const { activeProducts = [] } = company;
        return (activeProducts ?? []).some((p) => p.toLowerCase() === module.toLowerCase());
    }

    static formatRawXML(content) {
        const PADDING = '  '; // Two spaces for indentation
        const regExp = /(>)(<)(\/*)/g;
        let pad = 0;

        // Add newlines between tags
        let xml = content.slice(0);
        xml = xml.replace(regExp, '$1\r\n$2$3');

        return xml.split('\r\n').map((node) => {
            let indent = 0;

            if (node.match(/.+<\/\w[^>]*>$/)) {
                indent = 0; // Child and closing tag on same line
            } else if (node.match(/^<\/\w/)) {
                if (pad !== 0) pad -= 1; // Closing tag
            } else if (node.match(/^<\w[^>]*[^/]>.*$/)) {
                indent = 1; // Opening tag
            }

            const padding = PADDING.repeat(pad);
            pad += indent;
            return padding + node;
        }).join('\r\n');
    }
}
